
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import {
  dispatchCreateAccount,
  dispatchDeleteAccount,
  dispatchGetAccounts,
  dispatchUpdateAccount,
} from "@/store/task/actions";
import { readAccountList } from "@/store/task/getters";
import { compare, dateConversion, getLocalProject } from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects } from "@/store/project/getters";
import { readGetTokenLibraryList } from "@/store/performance/getters";
import {
  dispatchTokenLibraryCreate,
  dispatchTokenLibraryList,
  dispatchDeleteTokenList,
  dispatcTokenLibraryEdit,
} from "@/store/performance/actions";
@Options({
  components: {
    SideMenu,
  },
})
export default class AccountManage extends Vue {
  public value1 = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
  public accountForm = {
    account: "",
    password: "",
    remark: "",
    type: "",
    project: "",
  };
  public accountOptions = [
    { label: "QQ", value: 0 },
    { label: "Wechat", value: 1 },
    { label: "Other", value: 2 },
  ];
  public async edit(row) {
    row.check = true;

    await dispatcTokenLibraryEdit(store, {
      project: this.project,
      id: row.id,
      token: row.token,
      expiration_time: dateConversion(row.time),
    });
    await dispatchTokenLibraryList(store, {
      project: this.project,
    });
    this.tokenData();
  }
  public dateChange() {
    this.token_text = this.generateToken();
  }
  public token_text = "";
  public open() {
    this.dialogVisible = true;
    this.token_text = this.generateToken();
  }
  public searchChange() {
    this.tokenList = readGetTokenLibraryList(store).results.filter((token) =>
      token.token.includes(this.search)
    );
    this.tokenList?.forEach((v) => {
      v.expiration_time = dateConversion(v.expiration_time);
      v.time = dateConversion(v.expiration_time);
      v.check = true;
    });
  }
  public async deleteBtn(row) {
    if (!row.check) {
      row.check = true;
    } else {
      await dispatchDeleteTokenList(store, {
        project: this.project,
        id: row.id,
      });
      await dispatchTokenLibraryList(store, {
        project: this.project,
      });
      this.tokenData();
    }
  }

  public AccountFields = [
    { label: "更新者", prop: "update_user" },
    { label: "更新时间", prop: "update_date" },
  ];
  public tokenList = [];
  public tokenData() {
    this.tokenList = readGetTokenLibraryList(store).results;
    this.tokenList?.forEach((v) => {
      v.expiration_time = dateConversion(v.expiration_time);
      v.time = dateConversion(v.expiration_time);
      v.check = true;
    });
    return this.tokenList;
  }
  public search = "";
  public loading = false;
  public dialogVisible = false;
  public project = Number(getLocalProject());
  public newAccount = {
    account: "",
    password: "",
    type: "",
    remark: "",
  };

  public async mounted() {
    this.loading = true;
    await dispatchTokenLibraryList(store, {
      project: this.project,
    });
    this.tokenData();

    this.loading = false;
  }
  public generateToken() {
    const timestampPart = Date.now().toString(36);
    const randomPartLength = 32 - timestampPart.length;
    let randomPart = Math.random().toString(36).substr(2);

    while (randomPart.length < randomPartLength) {
      randomPart += Math.random().toString(36).substr(2);
    }

    return timestampPart + randomPart.slice(0, randomPartLength);
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.project
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  handleEdit(row: any, accountForm: any) {
    if (!row.isEdit) {
      row.isEdit = !row.isEdit;
      row.handleEditText = "取消";
      row.info = "info";
      row.isDanger = "primary";
      row.handleDeleteText = "提交";
      row.handleConfirmText = "确认更改账号?";
    } else {
      row.isEdit = !row.isEdit;
      row.isDanger = "danger";
      row.info = "warning";
      row.handleEditText = "编辑";
      row.handleDeleteText = "删除";
      row.handleConfirmText = "确认删除账号?";
    }
  }
  //编辑, 删除
  handleDeleteAccount(row: any, accountForm: any) {
    if (row.handleDeleteText === "提交") {
      // todo: 以更好的方式获取input selece value
      const commitForm: any = {};
      commitForm.project = row.project;
      commitForm.type = (document.getElementById(
        "type" + row.account_id
      ) as any).value;
      commitForm.account = (document.getElementById(
        "account" + row.account_id
      ) as any).value;
      const password = (document.getElementById(
        "password" + row.account_id
      ) as any).value;
      commitForm.remark = (document.getElementById(
        "remark" + row.account_id
      ) as any).value;

      if (commitForm.account === "") {
        alert("账号名称不能为空");
        return;
      }
      // 账号需要支持邮箱, 需要修改正则
      // if (!regChineseObJ.test(commitForm.account)) {
      //   alert_re_chinese("账号");
      //   return;
      // }
      // if (!regEnglishObj.test(password) && password !== "") {
      //   alert_re_english("密码");
      //   return;
      // }
      // if (!regChineseObJ.test(commitForm.remark)) {
      //   alert_re_chinese("备注");
      //   return;
      // }
      if (password === "") {
        delete commitForm.password;
      }

      // commitForm.password = Md5.hashStr(password).toString();
      commitForm.password = password;
      dispatchUpdateAccount(store, {
        id: row.account_id,
        account: commitForm,
      });
    } else {
      dispatchDeleteAccount(store, {
        id: row.account_id,
        project: row.project,
      });
    }
  }

  getAccounts(search: string) {
    const account_list: any[] = readAccountList(store);
    for (let account of account_list) {
      if (account.type === 0) {
        account.type_str = "QQ";
      } else if (account.type === 1) {
        account.type_str = "Wechat";
      } else {
        account.type_str = "Other";
      }
      account.update_timestamp = new Date(account.update_time).getTime();
      account.update_date = dateConversion(account.update_time);
      account.isEdit = false;
      account.handleEditText = "编辑";
      account.handleDeleteText = "删除";
      account.handleConfirmText = "确定删除账号？";
      account.isDanger = "danger";
      account.info = "warning";
    }
    return account_list
      .filter(
        (data) =>
          !search ||
          data.account?.toLowerCase().includes(search.toLowerCase()) ||
          data.type_str?.toLowerCase().includes(search.toLowerCase())
      )
      .sort(compare("update_timestamp"));
  }

  public async submitForm() {
    await dispatchTokenLibraryCreate(store, {
      project: this.project,
      token: this.token_text,
      expiration_time: dateConversion(this.value1),
    });
    await dispatchTokenLibraryList(store, {
      project: this.project,
    });
    this.tokenData();
    this.dialogVisible = false;
  }
}
